// Your custom JavaScript code goes here
document.addEventListener('DOMContentLoaded', function() {
    console.log('The VAB website is loaded!');
});

function toggleTopics (){

    var topics = $('#insight-topics.collapse');

    if (topics.length) {
        const w = $(window).width();
        if (w <= 768) {
            topics.collapse('hide')
        }
    }
}

toggleTopics();

$(function () {
    'use strict'

    $('[data-toggle="offcanvas"]').on('click', function () {
        $(this).toggleClass("is-active")
        $(this).attr('aria-expanded', $(this).hasClass('is-active') ? 'true' : 'false')
        $('.offcanvas-collapse').toggleClass('open')
        $('body').toggleClass('no-scroll')
    });
});

// Slick marks off-screen slides aria-hidden="true" but leaves the links and
// buttons inside them focusable — a Lighthouse accessibility failure
// ("[aria-hidden] elements contain focusable descendants"). Keep tabindex in
// sync on every slider on the page, on init and after every slide change.
function syncSlickTabindex($slider) {
    $slider.find('.slick-slide').each(function () {
        var $slide = $(this);
        var focusables = $slide.find('a, button, input, select, textarea, iframe');
        if ($slide.attr('aria-hidden') === 'true') {
            focusables.attr('tabindex', '-1');
        } else {
            focusables.removeAttr('tabindex');
        }
    });
}

$(document).on('init afterChange breakpoint', '.slick-slider', function () {
    syncSlickTabindex($(this));
});

// AOS is not initialized here. Only _singles/about.twig uses [data-aos], so it
// loads aos.js and calls AOS.init() itself, immediately after the script tag.
// Initializing from app.js would not work: app.js is loaded in layout.twig
// before {% block scripts %}, so AOS would not exist yet — and a `window.AOS`
// guard here would silently skip the init and leave About un-animated.

$(".latest-articles .scrollable-content ul").slick({
    infinite: true,
    speed: 300,
    accessibility: false,
    swipe: true,
    dots: true,
    arrows: false,
    touchMove: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1199,
        settings: "unslick"
    }, {
        breakpoint: 1023,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4
        }
    },{
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});


/*
 * Auto hide navbar
 */
jQuery(document).ready(function($){

    var $header = $('.navbar-autohide'),
        scrolling = false,
        previousTop = 0,
        currentTop = 0,
        scrollDelta = 10,
        scrollOffset = 150


    if ($(document).scrollTop() > 50) {
        $header.addClass("add-bg");
    } else {
        $header.removeClass("add-bg");
    }

    $(window).on('scroll', function(){

        if ($(document).scrollTop() > 50) {
            $header.addClass("add-bg");
        } else {
            $header.removeClass("add-bg");
        }

        if (!scrolling) {
            scrolling = true

            if (!window.requestAnimationFrame) {
                setTimeout(autoHideHeader, 250)
            }
            else {
                requestAnimationFrame(autoHideHeader)
            }
        }
    })

    function autoHideHeader() {
        const currentTop = $(window).scrollTop();

        // Scrolling up
        if (previousTop - currentTop > scrollDelta) {
            $header.removeClass('is-hidden')
        }
        else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            // Scrolling down
            $header.addClass('is-hidden')
        }

        previousTop = currentTop
        scrolling = false
    }
});

$(function() {
    let isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

    if (isMobile) {
        //Conditional script here
    }
});


$('.smooth-scroll').click(function() {

    const href = $(this).attr('href');

    $([document.documentElement, document.body]).animate({
        scrollTop: $(href).offset().top
    }, 1300);
});